/**
 * Social Media Feed Component
 * Auto-fetches thumbnails and titles from YouTube and Instagram post URLs
 */

if (!customElements.get('social-feed-component')) {
  customElements.define('social-feed-component', class SocialFeedComponent extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.tabs = this.querySelectorAll('[data-tab]');
      this.contents = this.querySelectorAll('[data-content]');

      this.initTabs();
      this.fetchAllData();
    }

    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          const tabName = tab.dataset.tab;
          this.switchTab(tabName);
        });
      });
    }

    switchTab(tabName) {
      this.tabs.forEach(tab => {
        tab.classList.toggle('is-active', tab.dataset.tab === tabName);
      });

      this.contents.forEach(content => {
        content.classList.toggle('is-active', content.dataset.content === tabName);
      });
    }

    async fetchAllData() {
      // Fetch YouTube video data (titles via oEmbed)
      const youtubeItems = this.querySelectorAll('[data-youtube-item]');
      const youtubePromises = Array.from(youtubeItems).map(item => this.fetchYouTubeData(item));

      // Wait for all to complete
      await Promise.allSettled(youtubePromises);
    }

    // YouTube: Auto-fetch video title using oEmbed API
    async fetchYouTubeData(item) {
      const videoId = item.dataset.videoId;
      const videoUrl = item.dataset.videoUrl;
      const titleEl = item.querySelector('[data-title]');
      const thumbnailContainer = item.querySelector('[data-thumbnail]');
      const img = thumbnailContainer?.querySelector('img');

      if (!videoId || !videoUrl) {
        if (titleEl) titleEl.textContent = 'Watch on YouTube';
        return;
      }

      // Ensure thumbnail is set
      if (img) {
        img.src = `https://img.youtube.com/vi/${videoId}/hqdefault.jpg`;
        img.alt = 'YouTube video';
      }

      // Fetch title from oEmbed API
      try {
        const oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(videoUrl)}&format=json`;
        const response = await fetch(oembedUrl);

        if (response.ok) {
          const data = await response.json();
          if (data.title && titleEl) {
            titleEl.textContent = data.title;
            if (img) img.alt = data.title;
          }
        } else {
          throw new Error('Failed to fetch');
        }
      } catch (error) {
        // Fallback title
        if (titleEl) titleEl.textContent = 'Watch on YouTube';
      }
    }

  });
}
